"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Button2 = _interopRequireDefault(require("./Button.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Button = function Button(_ref) {
  var _clsx;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      label = _ref.label,
      _ref$locked = _ref.locked,
      locked = _ref$locked === void 0 ? false : _ref$locked,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "submit" : _ref$type,
      ButtonProps = _ref.ButtonProps;
  var css = (0, _Button2.default)();

  var icon = /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "loader-1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.2",
    fill: "#000",
    d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
  }, /*#__PURE__*/_react.default.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 20 20",
    to: "360 20 20",
    dur: "0.5s",
    repeatCount: "indefinite"
  })));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.wrapper, "mco-form-button-wrapper", className)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    className: (0, _clsx2.default)(css.button, "mco-form-button", (_clsx = {}, _defineProperty(_clsx, css.isLocked, locked), _defineProperty(_clsx, "mco-form-button-is-locked", locked), _clsx)),
    disabled: locked,
    type: type
  }, ButtonProps), locked && icon, " ", /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};

var _default = Button;
exports.default = _default;